import * as actionTypes from './actionTypes';
import * as moduleActions from '../../Application/Components/Modules/moduleActions';
import * as notificationTypes from '../../Application/Components/Modules/Notification/notificationActions';


export const update_sublevel= (name)=>{
    return {
        type: actionTypes.UPDATE_SUBLEVEL,
        data: name
    }
}
export const setCurrentNode=(node)=>{
    return {
        type: actionTypes.SET_CURRENT_NODE,
        data: node
    }
}





